import React from "react";
import "./NavBar.css";
import { Link } from "react-router";

const navMenu = [
  {
    label: "Zero Wastage Food",
    img: "Zero_Wastage_Food.png",
    link: "/zero-wastage-food",
  },
  { label: "Khusi Ferao", img: "Khusi_Ferao.png", link: "/khushi-ferao" },
  { label: "Education Help", img: "Education_Help.png", link: "/education-help" },
  { label: "Oxygen Service", img: "Oxygen.png", link: "/medical-help" },
  { label: "DBD Service", img: "DBD.png", link: "/dbd" },
  { label: "Ambulance Service", img: "Ambulance_Service.png", link: "/medical-help" },
  { label: "Bina Paysar Bazar", img: "Bina_Paysar_Bazar.png", link: "/bina-paysar-bazar" },
  { label: "Nature Bachao", img: "Nature_Bachao.png", link: "/nature-bachao" },
  { label: "Sanitary Napkin Service", img: "Sanitary_Napkin.png", link: "/free-napkin" },
  { label: "Covid 19 Service", img: "Covid.png", link: "/covid-service" },
  { label: "Join as a Volunteer", img: "VOLUNTEER.png", link: "/apply-member" },
  { label: "Direct Blood Donate", img: "DBD_1.png", link: "/apply-dbd" },
];
const NavBar = () => {
  return (
    <>
      <div className="d-flex justify-around-content scroll-bar shadow  bg-white rounded ">
        {navMenu.map((item) => {
          return (
            <div className="p-2 bd-highlight" key={item.label}>
              <Link to={item.link}>
                <div className="image-wrapper">
                  <img
                    src={`/assets/img/mServiceLogo/${item.img}`}
                    alt="Avatar"
                    className="avatar"
                  />
                </div>
                <div className="avater-text justify-content-center">
                  {item.label}
                </div>
              </Link>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default NavBar;
